(function (window, $) {
  var Cls = {};
  var $earth = null;
  var $mainText = null;
  var $leadText = null;

  Cls.init = function (func) {
    window.scrollTo(0, -1); // reset scroll position that browser memorize
    $("#seg7").css({ visibility: "visible" });
    $earth = $("#seg7 .cat0 .obj1");
    $mainText = $("#seg7 .cat0 .obj3");
    $leadText = $("#seg7 .cat0 .obj4");

    $leadText.css({ opacity: "0" });
    $mainText.css({ opacity: "0" });

    Anime.vertical($earth, "-=0", 2000, 1000, "easeInOutCubic", up);
    function up() {
      $earth.animate({ top: "26px" }, 1500, "easeInOutQuart");
      Anime.fadeHalfSizeZoomIn($mainText, 3000, "easeOutQuint", 700);
      $leadText
        .css({ opacity: "0" })
        .delay(1300)
        .animate({ opacity: "1" }, 2000);
      setTimeout(func, 2000);
    }
  };

  window.Seg7 = Cls;
})(window, $brand);
